/**
 * Проверяет, содержит ли объект координаты в корректном формате.
 *
 * Координаты считаются валидными, если:
 * - поле `position` существует и является массивом длины 2;
 * - каждый элемент массива (широта и долгота) не равен `null`;
 * - значения не равны строке 'nan';
 * - значения не являются NaN (тип number).
 *
 * @param {Object} marker - Объект, содержащий поле `position` — массив с координатами [lat, lon].
 * @returns {boolean} true — если координаты валидны, иначе false.
 */
export const isValidMarker = (marker) => {
  if (!Array.isArray(marker.position) || marker.position.length !== 2) return false;

  const [lat, lon] = marker.position;

  return [lat, lon].every(
    (coord) => coord !== null && coord !== 'nan' && !isNaN(coord)
  );
};

/**
 * Фильтрует массив маркеров, оставляя только те, у которых валидные координаты.
 *
 * @param {Array<Object>} markers - Массив объектов, содержащих поле `position`.
 * @returns {Array<Object>} Только валидные маркеры.
 */
export const getValidMarkers = (markers = []) => {
  return Array.isArray(markers) ? markers.filter(isValidMarker) : [];
};
